export default "__VITE_ASSET__Bzi9x7r7__"